import React from "react";
import _ from "lodash";
import { NetworkAPI } from "apis";
import ChangeLogModal from "components/common/ChangeLogModal";
import {
  compareTwoObjectsDiff,
  FirstLookSortedArray,
  FirstLookUniqIdMap,
  CustomGroupRule,
  CustomRuleAliasKey,
} from "helpers/Compare";

import { TYPE } from "./Constants";

const buttonActionClass =
  "px-2 py-1 bg-gray-200 text-xs rounded border border-gray-400 whitespace-pre shadow hover:bg-gray-300 text-gray-900 font-semibold";

class ChangeHistoryButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChangeLogModalOpen: false,
      currentRule: null,
      currentType: null,
    };

    this.handleFetchData = this.handleFetchData.bind(this);
    this.handleCompareData = this.handleCompareData.bind(this);
    this.handleReplaceData = this.handleReplaceData.bind(this);
  }

  async handleFetchData(param) {
    const { networkId } = this.state;
    return await NetworkAPI.getNetworkCustomFirstLookChangeHistory({
      networkId,
      ...param,
    });
  }

  handleCompareData(from, to) {
    const result = {};
    _.values(TYPE).forEach((type) => {
      if (!from[type] && !to[type]) return;
      const diff = compareTwoObjectsDiff(
        from[type],
        to[type],
        FirstLookUniqIdMap,
        FirstLookSortedArray
      );
      if (diff.length > 0) {
        result[type] = diff;
      }
    });
    return result;
  }

  handleReplaceData(data) {
    const { handleReplaceData } = this.props;
    if (!handleReplaceData) return;
    handleReplaceData({
      ...data,
      cb: () => this.setState({ isChangeLogModalOpen: false }),
    });
  }

  handleOpenRule({ rule, type }) {
    this.setState({
      isChangeLogModalOpen: true,
      currentRule: rule,
      currentType: type,
    });
  }

  render() {
    const { isChangeLogModalOpen, currentRule, currentType } = this.state;
    const { networkId, networkInfo, refData } = this.props;

    return (
      <>
        <button
          type="button"
          className={buttonActionClass}
          onClick={() =>
            this.setState({
              isChangeLogModalOpen: true,
              currentRule: null,
              currentType: null,
            })
          }
        >
          Change History
        </button>

        {isChangeLogModalOpen && (
          <ChangeLogModal
            networkId={networkId}
            currentRule={currentRule}
            currentType={currentType}
            name={networkInfo.name}
            timezone={networkInfo.timezone}
            dataKey="setting"
            isFirstLook={true}
            refData={refData}
            groupRule={CustomGroupRule}
            aliasKey={CustomRuleAliasKey}
            fetchData={this.handleFetchData}
            compareData={this.handleCompareData}
            handleClose={() => this.setState({ isChangeLogModalOpen: false })}
            handleReplaceData={this.handleReplaceData}
          ></ChangeLogModal>
        )}
      </>
    );
  }
}

export default ChangeHistoryButton;
